import { CSSProperties } from "react";
import styled from "styled-components";

export const buttonStyle = {
  display: "flex", // Habilita o uso de Flexbox
  justifyContent: "center", // Centraliza o texto horizontalmente
  alignItems: "center", // Centraliza o texto verticalmente
  width: "300px", // Ajuste de largura
  fontSize: "28px", // Tamanho da fonte
  padding: "22px 40px", // Aumento no tamanho vertical do botão
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const formStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  border: "3px solid black",
  margin: "15px",
  padding: "20px",
  background: "#f0f4f7",
  borderRadius: "10px",
};

export const btnStyle: CSSProperties = {
  marginTop: 20,
  borderWidth: "3px",
  borderRadius: "12px",
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const ContainerModal = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
  margin-top: 18px;
  padding: 16px; /* Adiciona espaçamento interno */
  border: 2px solid #858986;
  background: rgb(0, 54, 68);
  border-radius: 10px; /* Aumenta a suavidade dos cantos */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15); /* Sombra mais elegante */
`;
export const ContainerModalPix = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleIndex = styled.h1`
  font-size: 35px;
  font-weight: bold;
  color: rgb(0, 54, 68); /* Altere para contraste melhor */
  margin-left: 15px;
`;
export const TitleModal = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  margin: 0 0 10px 0;
`;
export const TextModal = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #ffd700;
  margin-left: 15px;
`;
export const TextModal2 = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: rgb(255, 255, 255);
  margin-left: 15px;
`;
export const TextModalPix = styled.p`
  font-size: 1.125rem; /* 18px */
  font-weight: 600;
  color: #1b1919;
  background: rgba(40, 167, 69, 0.1);
  margin: 0;
  letter-spacing: 0.5px;
  padding: 10px;
  border-radius: 5px;
`;

export const TextPix = styled.p`
  font-size: 1rem;
  font-weight: 600;
  color: #28a745;
  margin: 0;
  text-align: center;
  background: rgba(40, 167, 69, 0.1);
  padding: 10px;
  border-radius: 5px;

  letter-spacing: 0.5px;
`;

export const AlertTextModal = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: #d9534f; /* Vermelho mais profissional para alerta */
  margin: 15px;
  text-align: center;
  background: rgba(217, 83, 79, 0.1); /* Fundo leve para destacar alerta */
  padding: 10px;
  border-radius: 5px;
`;
